import { browserStorage } from './setupBrowserStorage';
const { configureStore, getStore } = process.env.NODE_ENV === 'development'
  ? require('./configureStore')
  : require('./configureStore');

export {
  browserStorage,
  configureStore,
  getStore,
};